module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/additional-briefing-elite.a39b217d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/additional-briefing-elite.png
// module id = 3726
// module chunks = 11